import Navbar from '../home/components/Navbar';
import Pricing from '../home/components/Pricing';
import Footer from '../home/components/Footer';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-16 md:pt-20">
        <Pricing />
      </div>
      <Footer />
    </div>
  );
}
